import { useGetNoOfIncompletedTodoQuery } from "../features/api/apiSlice";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setStatus, toggleColor } from "../features/filter/filterSlice";
export default function Footer() {
  const { status, color } = useSelector((state) => state.filter);
  const dispatch = useDispatch();
  const { data } = useGetNoOfIncompletedTodoQuery();

  const handleFilterWithStatus = (value) => {
    dispatch(setStatus(value));
  };

  const handleFilterWithColor = (value) => {
    dispatch(toggleColor(value));
  };

  return (
    <div className="mt-4 flex justify-between text-xs text-gray-500">
      <p>{data > 1 ? `${data} tasks` : `${data} task`} left</p>
      <ul className={`flex space-x-1 items-center text-xs`}>
        <li
          className={`cursor-pointer ${status === "all" ? "font-bold" : ""}`}
          onClick={() => handleFilterWithStatus("all")}
        >
          All
        </li>
        <li>|</li>
        <li
          className={`cursor-pointer ${status === false ? "font-bold" : ""}`}
          onClick={() => handleFilterWithStatus(false)}
        >
          Incomplete
        </li>
        <li>|</li>
        <li
          className={`cursor-pointer ${status === true ? "font-bold" : ""}`}
          onClick={() => handleFilterWithStatus(true)}
        >
          Complete
        </li>
        <li></li>
        <li></li>
        <li
          className={`h-3 w-3 border-2 border-green-500 md:hover:bg-green-500 rounded-full cursor-pointer   ${
            color.includes("green") ? "bg-green-500" : ""
          }`}
          onClick={() => handleFilterWithColor("green")}
        ></li>
        <li
          className={`h-3 w-3 border-2 border-red-500 md:hover:bg-red-500 rounded-full cursor-pointer ${
            color.includes("red") ? "bg-red-500" : ""
          }`}
          onClick={() => handleFilterWithColor("red")}
        ></li>
        <li
          className={`h-3 w-3 border-2 border-yellow-500 md:hover:bg-yellow-500 rounded-full cursor-pointer ${
            color.includes("yellow") ? "bg-yellow-500" : ""
          }`}
          onClick={() => handleFilterWithColor("yellow")}
        ></li>
      </ul>
    </div>
  );
}
